import React, { ReactNode } from 'react'
import { PageContainer, PageWrapper } from './styles';
// import BackgroundImg from 'assets/images/bg.svg';

interface ILayout {
  children: ReactNode
}

const styles = {
  pageContainer: {
    background: 'var(--grayLv6)'
    // backgroundImage: `url(${BackgroundImg})`,
    // backgroundSize: 'cover'
  }
}  

export default function LoginPage({ children }: ILayout) {
  return (
    <PageContainer style={styles.pageContainer}>
      <PageWrapper>
        {children}
      </PageWrapper>

      <div style={{height: '40px', width: '100%', background: 'var(--black)'}} />
    </PageContainer>
  )
}
